export const sections = {
  FIRST: 'first',
  MIDDLE: 'middle',
  LAST: 'last',
}
